import { useQuery } from "@tanstack/react-query";
import axios from "../../axios";

export const useUser = () => {
  const query = useQuery({
    queryKey: ["user"],
    queryFn: async () => {
      const { data } = await axios.get("me");
      return data?.result;
    },
    staleTime: 2 * 60 * 1000,
    cacheTime: 3 * 60 * 1000,
  });

  return {
    ...query,
    refetchUser: query.refetch,
  };
};
